import { onMessage } from "firebase/messaging";
import { messaging } from "./config/firebaseConfig";

export const setupOnMessageListener = (onNotification) => {
  // Check if messaging is available before setting up the listener
  if (!messaging) {
    console.warn("Firebase Cloud Messaging is not available");
    return;
  }

  onMessage(messaging, (payload) => {
    if (onNotification) {
      onNotification(payload.notification);
    }

    if (Notification.permission === "granted") {
      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: payload.notification.icon,
      });
    }
  });
};
